import { Fragment } from 'react';

import { IPScrollablePane } from 'baseComponents';
import { IPPanel, IPPanelType } from 'baseComponents/Panel/IPPanel';
import { IPScrollbarVisibility } from 'baseComponents/ScrollablePane/IPScrollablePane';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackTokensGapExtraSmall } from 'globalStyles';
import { useTranslation } from 'react-i18next';
import { IResourcePanelProps } from './ResourcePanel';

/**
 * The whole ResourcePanel prop set, plus the close the panel chrome needs.
 *
 * `width` is deliberately IGNORED here: an IPPanel owns its own width on a phone, and a host's
 * desktop reading measure has nothing to say about it. It travels only because this panel takes the
 * host's props whole.
 */
interface IMobileResourcePanelProps extends IResourcePanelProps {
  onClose: () => void;
}

const MobileResourcePanel = (props: IMobileResourcePanelProps) => {
  const { t } = useTranslation(['translation']);

  return (
    <Fragment>
      <IPStack verticalFill>
        <IPStack.Item>
          <IPPanel
            headerText={props.title || t('translation:ResourcePanel.Title')}
            isOpen={true}
            onDismiss={() => props.onClose()}
            type={IPPanelType.custom}
          >
            <IPStack
              verticalFill
              styles={{
                root: {
                  paddingTop: 30,
                  paddingBottom: 10,
                  paddingLeft: 10,
                },
              }}
              tokens={globalStackTokensGapExtraSmall}
            >
              <IPStack.Item grow styles={{ root: { minHeight: 0 } }}>
                {props.scrollable !== false ? (
                  <IPScrollablePane
                    styles={{
                      root: {
                        top: 70,
                        left: 10,
                        right: 10,
                        position: 'absolute',
                      },
                    }}
                    scrollbarVisibility={IPScrollbarVisibility.auto}
                  >
                    {props.children}
                  </IPScrollablePane>
                ) : (
                  <IPStack
                    verticalFill
                    styles={{ root: { minHeight: 0, overflow: 'hidden', position: 'absolute', inset: '70px 10px 0' } }}
                  >
                    {props.children}
                  </IPStack>
                )}
              </IPStack.Item>
            </IPStack>
          </IPPanel>
        </IPStack.Item>
      </IPStack>
    </Fragment>
  );
};

export default MobileResourcePanel;
